module.exports = __webpack_public_path__ + "static/img/21094B_4_C_20240319_LC.a2b307e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/21094B_4_C_20240319_LC.png
// module id = iNic
// module chunks = 0